<template>
  <div>
    <h2 v-if="headline">{{headline}}</h2>
    <div class="loading-list">
      <div
        class="loading-list__item"
        :class="{'is-done':state.done, 'is-loading': !state.done}"
        :key="state.id"
        v-for="state in states"
      >
          {{state.text}}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'QuestionsProgress',
  props: {
    states: {
      type: Array,
      twoWay: true
    },
    headline: {
      type: String
    },
    show: {
      type: Boolean,
      default: false,
      twoWay: false
    },
    begin: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  watch: {
    'begin' (to, from) {
      if (this.begin) {
        this.next()
      }
    },
    'show' (to, from) {
      if (this.show) {
        // this.next()
      } else {
        this.states.map(state => { state.done = false })
      }
    }
  },
  methods: {
    getState () {
      // Get next state which is not done
      return this.states.find(state => {
        return state.done === false
      })
    },
    doSetTimeout () {
      // Dummy timeout function
      let min = 300
      let max = 1300
      let ms = Math.floor(Math.random() * (max - min + 1) + min)
      setTimeout(() => {
        this.next()
      }, ms)
    },
    next () {
      let currentState = this.getState()
      if (currentState) {
        currentState.done = true
        let doNextStateExist = this.getState()
        if (doNextStateExist) {
          this.doSetTimeout()
        } else {
          this.finish()
        }
      } else {
        this.finish()
      }
    },
    finish () {
      // Wait 300 ms, so we get to see the last check-sign
      setTimeout(() => {
        this.$emit('finish')
      }, 300)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/questions/QuestionsProgress.vue